<template>
  <div class="editable-cell">
    <div v-if="editable" class="editable-cell-input-wrapper">
      <!-- 类型为text -->
      <a-input
        v-if="inputType === 'text'"
        :value="value"
        @change="handleChange"
        style="width: 82%; margin-right: 4px"
        :placeholder="placeholder"
        @pressEnter="check"
      />
      <!-- 类型为数字,precision为精确小数点 -->
      <a-input-number
        v-model="value"
        @change="numberHandleChange"
        style="width: 82%; margin-right: 4px"
        :type="inputType"
        :precision="precision"
        :placeholder="placeholder"
        :min="min"
        @pressEnter="check"
        v-else
      />
      <!-- <a-icon type="check" class="editable-cell-icon-check" @click="check" /> -->
    </div>
    <div v-else class="editable-cell-text-wrapper" @click="edit">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: { // input的类型
      type: [Number, String],
      default: ''
    },
    precision: { // input为number类型时,默认为正数
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: this.text,
      editable: true,
      inputType: 'text',
      placeholder: '请输入内容',
      min: 0
    }
  },
  watch: {
    text (val) {
      this.value = val
    }
  },
  mounted () {
    // if (this.text === '') {
    //   this.editable = true
    // }
    this.inputType = this.$attrs.inputType || 'text'
    this.placeholder = this.$attrs.placeholder || '请输入内容'
    this.min = this.$attrs.min || 0
  },
  methods: {
    numberHandleChange (e) {
      let number = String(e)
      if(number.length > 16){
        this.$message.error('输入的价格过长,长度不能超过16位,请重新输入!')
        return
      }
      this.value = e
      this.$emit('change', this.value)
    },
    handleChange (e) {
      const value = e.target.value
      this.value = value
    },
    check () {
      if (this.value === '' || this.value === null) {
        this.editable = true
      }
      else {
        this.editable = false
        // this.$emit('change', this.value)
      }
    },
    edit () {
      this.editable = true
    }
  }
}
</script>
